let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kv290")).then(() => parcelRequire('gOAbs'));